function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  id: "a",
  d: "M28.49 9v5.486a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5V9H10.5A1.5 1.5 0 0 0 9 10.5v18.017a1.5 1.5 0 0 0 1.5 1.5h10.592c.714-5.103 5.097-9.031 10.398-9.031 1.6 0 3.117.358 4.475.999V10.5a1.5 1.5 0 0 0-1.5-1.5H28.49zm-3 0h-6v2.986h6V9zm-1.363 23.922a7.512 7.512 0 0 0 4.333 5.427c-1.278-1.786-2.068-3.597-2.351-5.427h-1.982zm.026-3h1.91c.208-1.71.858-3.403 1.935-5.075a7.512 7.512 0 0 0-3.845 5.075zm9.558 3H29.25c.41 1.403 1.262 3.082 2.23 4.544.968-1.462 1.82-3.14 2.23-4.544zm.11-3c-.34-1.51-1.233-3.312-2.34-4.878-1.109 1.566-2.002 3.367-2.342 4.878h4.682zm5.031 3h-2c-.285 1.834-1.078 3.65-2.36 5.44a7.512 7.512 0 0 0 4.36-5.44zm-.025-3a7.513 7.513 0 0 0-3.875-5.09c1.083 1.677 1.736 3.376 1.945 5.09h1.93zm.059-5.89a10.468 10.468 0 0 1 3.104 7.454c0 5.799-4.701 10.5-10.5 10.5-5.28 0-9.648-3.895-10.39-8.969H10.5a4.5 4.5 0 0 1-4.5-4.5V10.5A4.5 4.5 0 0 1 10.5 6h23.965a4.5 4.5 0 0 1 4.5 4.5v13.533h-.08zM13.49 26.987a1.5 1.5 0 1 1 0-3h3a1.5 1.5 0 0 1 0 3h-3z"
});

var SvgDeliveryInternational = function SvgDeliveryInternational(props) {
  return React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref);
};

export default SvgDeliveryInternational;


//////////////////
// WEBPACK FOOTER
// ./src/icons/shipment-status/delivery-international.svg
// module id = 135
// module chunks = 0 1